import React from "react";
import { useI18n } from "../i18n";

export function CTA() {
  const { t } = useI18n();

  return (
    <section className="py-20 px-6 onyx-cta-bg">
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t("cta.title")}
        </h2>
        <p className="text-lg text-[#8a7a9a] mb-10 max-w-xl mx-auto leading-relaxed">
          {t("cta.subtitle")}
        </p>
        <a
          href="/signup"
          className="inline-block px-10 py-4 bg-[#7b5ea7] hover:bg-[#6a4f96] text-white font-semibold rounded-lg transition-colors text-lg onyx-shimmer"
        >
          {t("cta.button")}
        </a>
      </div>
    </section>
  );
}
